export default __webpack_public_path__ + "static/media/warning.fb1fac38.svg";